import { FC, ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import './pageloader.css';

interface ContentLoaderProps {
  children: ReactNode;
  isLoading: boolean;
  message?: string;
  error?: string | null;
  onRetry?: () => void;
}

const ContentLoader: FC<ContentLoaderProps> = ({ 
  children, 
  isLoading, 
  message = "Loading content...", 
  error,
  onRetry 
}) => {
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] w-full p-6 text-center">
        <div className="p-4 rounded-full bg-red-100 dark:bg-red-900/20 mb-4">
          <svg
            className="w-8 h-8 text-red-600 dark:text-red-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Something went wrong
        </h3>
        <p className="text-gray-500 dark:text-gray-400 max-w-sm mb-6">
          {error}
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200 font-medium"
          >
            Try Again
          </button>
        )}
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] w-full">
        <Loader2 className="w-12 h-12 text-blue-500 animate-spin" />
        {message && (
          <p className="text-gray-500 dark:text-gray-400 font-medium animate-pulse mt-4">
            {message}
          </p>
        )}
      </div>
    );
  }

  return <>{children}</>;
};

export default ContentLoader;
